import './style.scss';
import { useState } from 'react';
import utility from 'src/utils/utility';
import {
  AbsoluteContainer,
  AppSpan,
  CustomContainer,
  FlexRow,
  PageTitle,
  PageWrapper,
} from 'src/style';
import { MonthlyBillingReport, ServiceProviderReport } from 'src/component';
import * as device from 'react-device-detect';

const tabsInfo = [
  { label: 'Monthly Billing Report', value: 'monthly-billing' },
];

const Reports = () => {
  const [selectedTab, setSelectedTab] = useState('monthly-billing');

  return (
    <PageWrapper>
      <PageTitle color="#101828" textSize="3" fontWeight="500">
        Report
      </PageTitle>
      <CustomContainer topMargin="2.5">
        <CustomContainer bottomMargin="2" className="scrollable-container">
          <FlexRow
            gap="2"
            height="4"
            alignItems="flex-start"
            className="tab-container"
          >
            {tabsInfo.map((item, index) => {
              return (
                <AppSpan
                  fontWeight={device.isFirefox ? '400' : '500'}
                  cursor="pointer"
                  color={selectedTab === item.value ? '#0A756F' : '#667085'}
                  onClick={() => setSelectedTab(item.value)}
                  key={index}
                >
                  {item.label}
                </AppSpan>
              );
            })}
            <AbsoluteContainer
              bottom="0"
              left={selectedTab === 'monthly-billing' ? '0' : '14.4'}
            >
              <CustomContainer
                width={'16'}
                height="0.2"
                bgColor="#0A756F"
              />
            </AbsoluteContainer>
          </FlexRow>
        </CustomContainer>
        {selectedTab === 'monthly-billing' ? (
          <MonthlyBillingReport />
        ) : (
          <ServiceProviderReport />
        )}
      </CustomContainer>
    </PageWrapper>
  );
};

export default utility.routeData('reports', 'Reports', <Reports />);
